import React, { useState, useEffect } from "react";
import { Nav } from '@themesberg/react-bootstrap';
import CreditPackagePayments from '../payments/CreditPackagePayments';
import CreditPackagesList from './CreditPackagesList';
import CreditPackagesAdd from './CreditPackagesAdd';

export default () => {
  const [activeTab, setActiveTab] = useState("payments"); // "payments", "list", "add"

  // Tab değiştirme event'ini dinle (CreditPackagesAdd'den gelen)
  useEffect(() => {
    const handleTabSwitch = (event) => {
      setActiveTab(event.detail);
    };
    window.addEventListener('switchToTab', handleTabSwitch);
    return () => {
      window.removeEventListener('switchToTab', handleTabSwitch);
    };
  }, []);

  return (
    <>
      <div className="py-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Kredi Paket Ödemeleri</h4>
        <div className="d-flex gap-2">
          <Nav variant="tabs" className="border-0">
            <Nav.Item>
              <Nav.Link
                eventKey="list"
                active={activeTab === "list"}
                onClick={() => setActiveTab("list")}
                className={activeTab === "list" ? "active" : ""}
                style={{ 
                  cursor: 'pointer',
                  color: activeTab === "list" ? '#fff' : '#6c757d',
                  backgroundColor: activeTab === "list" ? '#5e72e4' : 'transparent',
                  border: 'none',
                  fontSize: 'calc(1rem + 4px)',
                  fontWeight: 'bold'
                }}
              >
                Kredi Paketleri Listele
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="add"
                active={activeTab === "add"}
                onClick={() => setActiveTab("add")}
                className={activeTab === "add" ? "active" : ""}
                style={{ 
                  cursor: 'pointer',
                  color: activeTab === "add" ? '#fff' : '#6c757d',
                  backgroundColor: activeTab === "add" ? '#5e72e4' : 'transparent',
                  border: 'none',
                  fontSize: 'calc(1rem + 4px)',
                  fontWeight: 'bold'
                }}
              >
                Kredi Paketi Ekle
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="payments"
                active={activeTab === "payments"}
                onClick={() => setActiveTab("payments")}
                className={activeTab === "payments" ? "active" : ""}
                style={{ 
                  cursor: 'pointer',
                  color: activeTab === "payments" ? '#fff' : '#6c757d',
                  backgroundColor: activeTab === "payments" ? '#5e72e4' : 'transparent',
                  border: 'none',
                  fontSize: 'calc(1rem + 4px)',
                  fontWeight: 'bold'
                }}
              >
                Kredi Ödemelerini Gör
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </div>

      {activeTab === "payments" && <CreditPackagePayments />}
      {activeTab === "list" && <CreditPackagesList />}
      {activeTab === "add" && <CreditPackagesAdd />}
    </>
  );
};

